export default __webpack_public_path__ + "static/media/8.20534ed9.svg";